import React from 'react';
import collegeLogo from '../assets/images/logo_clg.webp';

function Footer() {
  return (
    <footer>
      <div className="footer">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-12 col-md-6 mb-4 mb-md-0 d-flex flex-column align-items-center">
              <div className="mb-4">
                <img src={collegeLogo} alt="ACSR Logo" height="70" className="mb-3 logo" />
                <h5>A.C.S.R Government Medical College</h5>
              </div>
              <p>Established in 2014, A.C.S.R Government Medical College is affiliated to Dr. NTR University of Health Sciences with an intake capacity of 175 MBBS seats. The campus spreads across 67.5 acres in the heart of Nellore.</p>
            </div>
            {/* Removed Quick Links section as per user request */}
            <div className="col-12 col-md-4 d-flex flex-column align-items-center">
              <h5>Contact Info</h5>
              <address className="mb-0">
                A.C.S.R<br />
                GOVERNMENT MEDICAL COLLEGE<br />
                Nellore, Andhra Pradesh 524003<br /><br />
                <strong>Email:</strong> acsrgmcnlr@gmail.com
              </address>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <p className="mb-0">&copy; {new Date().getFullYear()} A.C.SUBBA REDDY GOVERNMENT MEDICAL COLLEGE. All rights reserved.</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 
